<ng-container *transloco="let t; read: 'ime.manufacturing.manufacturing-item'">
  <ng-container *ngIf="(filteredItems$ | async) as allItems; else loading">
    <ng-select #select class="select-sm form-control" bindLabel="DisplayName" bindValue="Id" appendTo="body"
               [name]="name"
               [placeholder]="placeholder"
               [items]="allItems"
               [editableSearchTerm]="true"
               [virtualScroll]="true"
               [multiple]="multiple"
               [disabled]="readonly"
               [typeahead]="searchInput$"
               [ngModel]="multiple ? entityIds : entityId" (ngModelChange)="multiple ? entityIds : entityId = $event"
               (open)="select.searchTerm = select.itemsList.selectedItems[0]?.value?.Code"
               (change)="onSelectionChanged($event)">
      <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <ng-container *ngIf="multiple">
          <span class="ng-value-icon left" (click)="clear(item); select.close()" aria-hidden="true">×</span>
          <span class="ng-value-icon left" (click)="editExisting(item); select.close()"><svg viewBox="0 0 6 8" class="icon small" inlineSVG="#pencil"></svg></span>
        </ng-container>
        <span class="ng-value-label">
          {{item | displayName}}
          <span *ngIf="item.StatusClv === Classificators.ItemStatus.Draft" class="badge bg-default" title="{{t('Draft')}}">D</span>
        </span>
      </ng-template>
      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
        <ng-container [ngTemplateOutlet]="option" [ngTemplateOutletContext]="{item: item, searchTerm: search}">
        </ng-container>
      </ng-template>
      <ng-template ng-footer-tmp>
        <ng-container [ngTemplateOutlet]="footer" [ngTemplateOutletContext]="{select: select}">
        </ng-container>
      </ng-template>
      <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
        <ng-container [ngTemplateOutlet]="notfound"
                      [ngTemplateOutletContext]="{select: select, searchTerm: searchTerm}">
        </ng-container>
      </ng-template>
    </ng-select>
  </ng-container>
  <ng-template #loading>{{t('Loading')}}...</ng-template>
  <ng-template #notfound let-searchTerm="searchTerm" let-select="select">
    <div class="ng-option disabled">
      <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="select.close(); addNew(searchTerm)" *ngIf="allowAdd">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
        {{t('Add')}} "{{searchTerm}}"
      </button>
    </div>
  </ng-template>
  <ng-template #option let-item="item" let-searchTerm="searchTerm">
    <div class="d-flex justify-content-between text-wrap text-break ms-n1 bl-3 border-secondary">
      <app-item-display-name [item]="item" [searchTerm]="searchTerm"/>
      <a href="/manufacturing/item/edit/{{item.Id}}" target="_blank" class="show-on-option-hover my-auto me-1" (click)="$event.stopPropagation()">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#arrow-top-right-on-square"></svg>
      </a>
    </div>
  </ng-template>
  <ng-template #footer let-select="select">
    <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="select.close(); addNew()" *ngIf="allowAdd">
      <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
      {{t('Item')}}
    </button>
    <ng-container *ngIf="entityId">
      <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="select.close(); editExisting()" *ngIf="allowEdit">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
      </button>
    </ng-container>
  </ng-template>
</ng-container>
